import { render, staticRenderFns } from "./Dummy.vue?vue&type=template&id=cb7946b0&scoped=true&"
import script from "./Dummy.vue?vue&type=script&lang=ts&"
export * from "./Dummy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7946b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb7946b0')) {
      api.createRecord('cb7946b0', component.options)
    } else {
      api.reload('cb7946b0', component.options)
    }
    module.hot.accept("./Dummy.vue?vue&type=template&id=cb7946b0&scoped=true&", function () {
      api.rerender('cb7946b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dummy.vue"
export default component.exports